<template>
  <div>
    <div class="d-flex justify-content-end mb-1">
      <add-button
        v-if="activeAddButton"
        :btn-label="'Category'"
        @click.native="$router.push('/article/article/category/create')"
      />
    </div>
    <div
      class="d-flex flex-wrap align-items-end horoscope-type-filter-container justify-content-end"
    >
      <div class="mr-1 ml-1 mb-1">
        <v-select
          id="horoscope-type-status"
          v-model="form.status"
          :searchable="false"
          class="horoscope-type-status-filter bg-dropdown"
          :class="form.status ? 'horoscope-type-status-selected' : null"
          placeholder="All Status"
          :options="statusOption"
          @input="option => onSelectFilter('status', option)"
        />
      </div>
      <div class="search-container mb-1">
        <search :on-search-input="onSearchCategory" />
      </div>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import Search from '@/views/components/search/Search.vue'
import CalendarPickerIcon from '@/@core/components/svg/common/CalendarPicker.vue'
import AddButton from '@/views/components/button/AddButton.vue'
import vSelect from 'vue-select'
import { reactive } from '@vue/composition-api'

export default {
  components: {
    BFormGroup,
    BFormInput,
    Search,
    CalendarPickerIcon,
    AddButton,
    flatPickr,
    vSelect,
  },
  props: {
    statusOption: Array,
    onSearchCategory: Function,
    onSelectFilter: Function,
    activeAddButton: Boolean
  },
  setup() {
    const flatPickrDateConfig = reactive({
      allowInput: true,
      altFormat: 'F j, Y',
      dateFormat: 'd-m-Y',
      minDate: null,
      onReady(selectedDate, dateStr, instance) {
        const el = instance.element
        const preventInput = event => {
          event.preventDefault()
          return false
        }
        el.onkeypress = preventInput
        el.onkeydown = preventInput
        el.onkeyup = preventInput
        el.onpaste = preventInput
        el.style.caretColor = 'tranparent'
        el.style.cursor = 'pointer'
      },
    })
    const form = reactive({
      validFrom: null,
      validThrough: null,
      status: null,
    })
    return {
      flatPickrDateConfig,
      form,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style scoped>
@import '~@/assets/css/pages/data-management.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/article/article-filter-header.css';
</style>
